import React from 'react';
import { withStyles } from 'material-ui/styles';

const styles = {
  hr: {
    border: '0',
    height: '0',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem'
  }
};

const Hr = ({ classes }) => <hr className={classes.hr} />;

export default withStyles(styles, { name: 'Hr' })(Hr);



// WEBPACK FOOTER //
// ./src/components/Hr.js